import type { Season } from "@/features/seasons/models/season";
import { Hint, InlineCopy } from "@cmde/shadcn";
import { useTranslation } from "react-i18next";

export function SeasonNameCell({ season }: { season: Season }) {
  const { t } = useTranslation();

  return (
    <Hint content={t("seasons.list.table.copyId")}>
      <span className="inline-flex">
        <InlineCopy content={season.seasonId}>{season.name}</InlineCopy>
      </span>
    </Hint>
  );
}
